// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t303 · UN SISTEMA DE LA CLÍNICA APAGADO, EN EL NAVEGADOR (19-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El servidor manda en los permisos los ids de los sistemas apagados en esta clínica (`_sistemas_apagados`,
//  backend/services/permisos · aplicarSistemasApagados, que los saca de services/sistemasClinica): los que ha apagado la
//  clínica, Biango para todas, su licencia, lo de una función en desarrollo apagada y lo de ALTA EXPRESA que Biango no le ha
//  activado (hoy, la pantalla de sala). Esto es lo que lo mira para lo que no cuelga de un permiso propio:
//   · `sistemaEncendido(perms, id)`: SOLO cuando la respuesta ya ha llegado y no lo nombra. Mientras carga, no: mejor que
//     algo aparezca un instante tarde que enseñarlo y quitarlo (lo mismo que components/SoloConRadiologia).
//   · `useSistema(id)`: lo mismo, como gancho (hooks/useLlamarSala: los botones «Llamar por la tele»).
//   · `SoloConSistema`: la puerta de una ruta (App.jsx). Cargando, nada; apagado, al inicio.
//  El servidor cierra por su cuenta (403 «módulo apagado»): esconder aquí no es la seguridad, es no enseñar lo que no hay.
import { Navigate } from 'react-router-dom'
import { usePermisos } from '../hooks/usePermisos'

export function sistemaEncendido(perms, id) {
  return Array.isArray(perms?._sistemas_apagados) && !perms._sistemas_apagados.includes(String(id))
}

export function useSistema(id) {
  const { perms } = usePermisos()
  return sistemaEncendido(perms, id)
}

export default function SoloConSistema({ id, children }) {
  const { perms, permisosListos } = usePermisos()
  if (sistemaEncendido(perms, id)) return children
  if (!permisosListos) return null
  return <Navigate to="/" replace />
}
